import swiperUtil from '../utils/swiper-util';
import { addToCart } from '~/js/lib/cart'; // eslint-disable-line

export default (node) => {
  /**
   * Data + elements
   */
  const swiperNode = node.querySelector('[data-swiper]');
  const addToCartButton = node.querySelector('[data-enable-add-to-cart]');
  const variantsContainer = node.querySelector('[data-product-card-variants]');
  const defaultImage = node.querySelector('[data-default-image]');
  const allLinks = node.querySelectorAll('a');

  /**
   * Functions
   */
  const initSwiper = () => {
    swiperUtil(swiperNode, {
      spaceBetween: 0,
      pagination: {
        el: node.querySelector('[data-swiper-pagination]'),
        clickable: true,
      },
    });
  };

  const handleAddToCart = async (e) => {
    e.preventDefault();

    const variantId = addToCartButton.dataset.enableAddToCart;

    const itemToAdd = [
      {
        id: Number(variantId),
        quantity: 1,
      },
    ];
    await addToCart(itemToAdd);

    // Emit event to open cart
    document.dispatchEvent(new CustomEvent('cart:open'));
  };

  const handleVariantSwitch = (e) => {
    const swatch = e.target.closest('[data-swatch]');

    if (!swatch) return;

    // Get variant data from swatch
    const variantUrl = swatch.dataset.variantUrl;
    const colorName = swatch.dataset.colorName;

    if (!variantUrl || !colorName) return;

    // Toggle variant images opacity
    const variantImages = node.querySelectorAll('[data-variant-color]');

    // Hide default image (only if it's currently visible)
    if (defaultImage && !defaultImage.classList.contains('opacity-0')) {
      defaultImage.classList.remove('opacity-100');
      defaultImage.classList.add('opacity-0');
    }

    // Hide all variant images and show the selected one
    variantImages.forEach((img) => {
      if (img.dataset.variantColor === colorName) {
        img.classList.remove('opacity-0');
        img.classList.add('opacity-100');
      } else {
        img.classList.remove('opacity-100');
        img.classList.add('opacity-0');
      }
    });

    // Update all links in the card to point to the selected variant
    allLinks.forEach((link) => {
      link.href = variantUrl;
    });

    // Update active state on swatches
    if (!variantsContainer) return;
    const allSwatches = variantsContainer.querySelectorAll('[data-swatch]');
    if (!allSwatches) return;
    allSwatches.forEach((s) => {
      if (s === swatch) {
        s.classList.remove('border', 'border-control-inactive-primary');
        s.classList.add(
          'border-[3px]',
          'border-control-invert-active',
          'outline-2',
          'outline',
          'outline-control-active'
        );
      } else {
        s.classList.remove(
          'border-[3px]',
          'border-control-invert-active',
          'outline-2',
          'outline',
          'outline-control-active'
        );
        s.classList.add('border', 'border-control-inactive-primary');
      }
    });
  };

  /**
   * Init
   */
  const init = () => {
    if (swiperNode) initSwiper();

    if (addToCartButton) {
      addToCartButton.addEventListener('click', handleAddToCart);
    }

    // Add variant switching functionality
    if (variantsContainer) {
      variantsContainer.addEventListener('click', handleVariantSwitch);
    }
  };

  init();
};
